module.exports = __webpack_public_path__ + "static/img/s-mi-1.b8c886e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-mi-1.png
// module id = l0zF
// module chunks = 1